enum QueryKeysEnum {
  allowanceOfSelectedAsset = 'allowanceOfSelectedAsset',
  terraAssetsJson = 'terraAssetsJson',
}

export default QueryKeysEnum
